// global shared items
require('./shared')

require('./shared_functions')
require('../site_scripts/mtc_carz_mobile_menu')
require('../global/read-more')
require('../global/modal')
require('../site_scripts/mtc_lazy_load_recaptcha_form')
require('../site_scripts/mtc_simple_form_submit')
require('../site_scripts/mtc_simple_tabs')

require('../../styles/entry/carz-offer.less')
